import styled from "styled-components";
import { defaultTheme } from "styles/theme/default";

export const Card = styled.div`
  background: ${defaultTheme.colors["white-100"]};
  border: 1px solid ${defaultTheme.colors["white-box"]};
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
`;

export const CardTitle = styled.div`
  font-family: ${defaultTheme.fonts.title};
  font-weight: 600;
  font-size: 0.95rem;
  color: ${defaultTheme.colors.black};
  margin-bottom: 8px;
`;

export const CardRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.85rem;
  color: ${defaultTheme.colors["gray-300"]};
  padding: 4px 0;

  strong {
    color: ${defaultTheme.colors.black};
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  color: ${defaultTheme.colors["gray-200"]};
  padding: 32px 16px;
  font-size: 0.9rem;
`;
